import { isNullOrEmpty } from "@utils/string";

import {
  EducationCourseType,
  EducationProviderItem,
  EducationRegion,
  EducationSearchItem,
} from "types/EducationProviderItem";

export const filterQuery = (
  query: string,
  unfilteredList: Array<EducationProviderItem>,
  searchList: Array<EducationSearchItem>,
): Array<EducationProviderItem> => {
  let filteredList: Array<EducationProviderItem> = [];
  const lowerCaseQuery = query.toLowerCase();
  const searchItem: EducationSearchItem = searchList?.filter(
    (item: EducationSearchItem) => item.name.trim() === query,
  )[0];

  if (searchItem?.type === 0) {
    filteredList = unfilteredList?.filter((item: EducationProviderItem) =>
      item?.name?.toLowerCase().includes(lowerCaseQuery),
    );
  } else {
    unfilteredList?.forEach((item: EducationProviderItem) => {
      const regions = item?.regions;
      regions?.find((r: EducationRegion) => r.name.toLowerCase() === lowerCaseQuery)
        ? filteredList?.push(item)
        : "";
    });
  }
  return filteredList;
};

export const filterCourses = (
  courses: string,
  unfilteredList: Array<EducationProviderItem>,
): Array<EducationProviderItem> => {
  const filteredList: Array<EducationProviderItem> = [];

  unfilteredList?.forEach((item: EducationProviderItem) => {
    const courseTypes = item?.courseTypes;
    courseTypes?.find(
      (c: EducationCourseType) => courses?.indexOf(c.courseTypeCode.toString()) > -1,
    )
      ? filteredList?.push(item)
      : "";
  });
  return filteredList;
};

export const getNewPath = (courseSearch: CourseSearch) => {
  if (isNullOrEmpty(courseSearch?.query) && isNullOrEmpty(courseSearch?.courseTypes)) {
    return `/anslutna-utbildningsanordnare`;
  }

  const queryString = Object.keys(courseSearch)
    .flatMap((key) => (courseSearch[key] ? key + "=" + courseSearch[key] : []))
    .join("&");

  return `/anslutna-utbildningsanordnare?${queryString}`;
};

export const CourseTypes = {
  open: 1,
  digital: 2,
  business: 3,
  online: 4,
};

export type CourseSearch = {
  query?: string;
  courseTypes?: string;
};
